/*
 * @Author       : zhangbobo01 zhangbobo01@baidu.com
 * @Date         : 2023-12-19 11:20:22
 * @LastEditors  : zhangbobo01 zhangbobo01@baidu.com
 * @LastEditTime : 2024-01-09 14:50:38
 * @FilePath     : /ticket-plat-frontend/src/config/xsOnline.ts
 */
// 智能助手
import {ENV_CONFIG} from './index';
const ZNZS_HOST = 'https://console.bce.baidu.com/znzs';
const SUPPORT_HOST = 'https://console.bce.baidu.com/support';

const config: ENV_CONFIG = {
    MATCHER: new RegExp(/^console\.vcp\.baidu/g),
    CONSOLE_HOST: 'https://console.vcp.baidu.com',
    IS_XS: true,
    MOBILE_TICKET_HOST: 'ctssmartprogram.baidu.com',
    // 自助服务
    TOOLS_HOST: 'https://console.bce.baidu.com/tools',
    TOOL_HOST: 'https://console.bce.baidu.com/tools/?header=hidden&u=ticket-home#/index',
    CLOUD_HOST: 'https://cloud.baidu.com',
    CONSOLE_LOGIN_HOST: 'https://login.bce.baidu.com/',
    // 云音
    VOC_HOST: 'https://console.bce.baidu.com/voc/',
    // 智能助手
    ZNZS_HOST,
    // 智能助手h5
    ZNZS_H5_HOST: `${ZNZS_HOST}/znzs-app`,
    // 浮窗打开小助手拦截地址
    ZNZS_H5_WINDOW_URL: `${ZNZS_HOST}/?enable_help_center=true&help_center_type=znzs&platform=ticket`,
    // 埋点 appTag
    APP_TAG: 'ticket-plat-xs-online',
    ACA_HOST: 'https://console.bce.baidu.com/aca',
    // 服务与支持
    SUPPORT_HOST,
};

export default config;
